/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { PractitionerBaseService } from '../practitioner-base-service';
import { PractitionerApiConfiguration } from '../practitioner-api-configuration';
import { PractitionerStrictHttpResponse } from '../practitioner-strict-http-response';

import { consumerDeleteRoleRoleIdDelete } from '../fn/consumer/consumer-delete-role-role-id-delete';
import { ConsumerDeleteRoleRoleIdDelete$Params } from '../fn/consumer/consumer-delete-role-role-id-delete';
import { consumerGet } from '../fn/consumer/consumer-get';
import { ConsumerGet$Params } from '../fn/consumer/consumer-get';
import { consumerGetPractitionerFromRolePractitionerRoleIdGet } from '../fn/consumer/consumer-get-practitioner-from-role-practitioner-role-id-get';
import { ConsumerGetPractitionerFromRolePractitionerRoleIdGet$Params } from '../fn/consumer/consumer-get-practitioner-from-role-practitioner-role-id-get';
import { consumerLobbiesGet } from '../fn/consumer/consumer-lobbies-get';
import { ConsumerLobbiesGet$Params } from '../fn/consumer/consumer-lobbies-get';
import { consumerPersonIdGet } from '../fn/consumer/consumer-person-id-get';
import { ConsumerPersonIdGet$Params } from '../fn/consumer/consumer-person-id-get';
import { consumerPersonIdPhotoGet } from '../fn/consumer/consumer-person-id-photo-get';
import { ConsumerPersonIdPhotoGet$Params } from '../fn/consumer/consumer-person-id-photo-get';
import { consumerPersonIdSaveRolesPost } from '../fn/consumer/consumer-person-id-save-roles-post';
import { ConsumerPersonIdSaveRolesPost$Params } from '../fn/consumer/consumer-person-id-save-roles-post';
import { consumerPersonIdThumbnailGet } from '../fn/consumer/consumer-person-id-thumbnail-get';
import { ConsumerPersonIdThumbnailGet$Params } from '../fn/consumer/consumer-person-id-thumbnail-get';
import { consumerPhotoPost } from '../fn/consumer/consumer-photo-post';
import { ConsumerPhotoPost$Params } from '../fn/consumer/consumer-photo-post';
import { consumerPost } from '../fn/consumer/consumer-post';
import { ConsumerPost$Params } from '../fn/consumer/consumer-post';
import { consumerPractitionerIdSignatureGet } from '../fn/consumer/consumer-practitioner-id-signature-get';
import { ConsumerPractitionerIdSignatureGet$Params } from '../fn/consumer/consumer-practitioner-id-signature-get';
import { consumerSearchAsyncPost } from '../fn/consumer/consumer-search-async-post';
import { ConsumerSearchAsyncPost$Params } from '../fn/consumer/consumer-search-async-post';
import { PractitionerLobbyModel } from '../models/practitioner-lobby-model';
import { PractitionerModel } from '../models/practitioner-model';
import { PractitionerProfileModel } from '../models/practitioner-profile-model';
import { PractitionerRoleModel } from '../models/practitioner-role-model';

@Injectable({ providedIn: 'root' })
export class PRACConsumerService extends PractitionerBaseService {
  constructor(config: PractitionerApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `consumerSearchAsyncPost()` */
  static readonly ConsumerSearchAsyncPostPath = '/Consumer/SearchAsync';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerSearchAsyncPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerSearchAsyncPost$Response(params?: ConsumerSearchAsyncPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerProfileModel>>> {
    return consumerSearchAsyncPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerSearchAsyncPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerSearchAsyncPost(params?: ConsumerSearchAsyncPost$Params, context?: HttpContext): Observable<Array<PractitionerProfileModel>> {
    return this.consumerSearchAsyncPost$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<Array<PractitionerProfileModel>>): Array<PractitionerProfileModel> => r.body)
    );
  }

  /** Path part for operation `consumerPersonIdPhotoGet()` */
  static readonly ConsumerPersonIdPhotoGetPath = '/Consumer/{personId}/Photo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPersonIdPhotoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPersonIdPhotoGet$Response(params: ConsumerPersonIdPhotoGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<void>> {
    return consumerPersonIdPhotoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPersonIdPhotoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPersonIdPhotoGet(params: ConsumerPersonIdPhotoGet$Params, context?: HttpContext): Observable<void> {
    return this.consumerPersonIdPhotoGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `consumerPractitionerIdSignatureGet()` */
  static readonly ConsumerPractitionerIdSignatureGetPath = '/Consumer/{practitionerId}/Signature';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPractitionerIdSignatureGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPractitionerIdSignatureGet$Response(params: ConsumerPractitionerIdSignatureGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<void>> {
    return consumerPractitionerIdSignatureGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPractitionerIdSignatureGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPractitionerIdSignatureGet(params: ConsumerPractitionerIdSignatureGet$Params, context?: HttpContext): Observable<void> {
    return this.consumerPractitionerIdSignatureGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `consumerPersonIdThumbnailGet()` */
  static readonly ConsumerPersonIdThumbnailGetPath = '/Consumer/{personId}/Thumbnail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPersonIdThumbnailGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPersonIdThumbnailGet$Response(params: ConsumerPersonIdThumbnailGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<void>> {
    return consumerPersonIdThumbnailGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPersonIdThumbnailGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPersonIdThumbnailGet(params: ConsumerPersonIdThumbnailGet$Params, context?: HttpContext): Observable<void> {
    return this.consumerPersonIdThumbnailGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `consumerGetPractitionerFromRolePractitionerRoleIdGet()` */
  static readonly ConsumerGetPractitionerFromRolePractitionerRoleIdGetPath = '/Consumer/GetPractitionerFromRole/{practitionerRoleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerGetPractitionerFromRolePractitionerRoleIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerGetPractitionerFromRolePractitionerRoleIdGet$Response(params: ConsumerGetPractitionerFromRolePractitionerRoleIdGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<PractitionerProfileModel>> {
    return consumerGetPractitionerFromRolePractitionerRoleIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerGetPractitionerFromRolePractitionerRoleIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerGetPractitionerFromRolePractitionerRoleIdGet(params: ConsumerGetPractitionerFromRolePractitionerRoleIdGet$Params, context?: HttpContext): Observable<PractitionerProfileModel> {
    return this.consumerGetPractitionerFromRolePractitionerRoleIdGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<PractitionerProfileModel>): PractitionerProfileModel => r.body)
    );
  }

  /** Path part for operation `consumerGet()` */
  static readonly ConsumerGetPath = '/Consumer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerGet$Response(params?: ConsumerGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<PractitionerModel>> {
    return consumerGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerGet(params?: ConsumerGet$Params, context?: HttpContext): Observable<PractitionerModel> {
    return this.consumerGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<PractitionerModel>): PractitionerModel => r.body)
    );
  }

  /** Path part for operation `consumerPost()` */
  static readonly ConsumerPostPath = '/Consumer';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerPost$Response(params?: ConsumerPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
    return consumerPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerPost(params?: ConsumerPost$Params, context?: HttpContext): Observable<string> {
    return this.consumerPost$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `consumerPersonIdGet()` */
  static readonly ConsumerPersonIdGetPath = '/Consumer/{personId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPersonIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPersonIdGet$Response(params: ConsumerPersonIdGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerRoleModel>>> {
    return consumerPersonIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPersonIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerPersonIdGet(params: ConsumerPersonIdGet$Params, context?: HttpContext): Observable<Array<PractitionerRoleModel>> {
    return this.consumerPersonIdGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<Array<PractitionerRoleModel>>): Array<PractitionerRoleModel> => r.body)
    );
  }

  /** Path part for operation `consumerPersonIdSaveRolesPost()` */
  static readonly ConsumerPersonIdSaveRolesPostPath = '/Consumer/{personId}/SaveRoles';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPersonIdSaveRolesPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerPersonIdSaveRolesPost$Response(params: ConsumerPersonIdSaveRolesPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
    return consumerPersonIdSaveRolesPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPersonIdSaveRolesPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerPersonIdSaveRolesPost(params: ConsumerPersonIdSaveRolesPost$Params, context?: HttpContext): Observable<string> {
    return this.consumerPersonIdSaveRolesPost$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `consumerDeleteRoleRoleIdDelete()` */
  static readonly ConsumerDeleteRoleRoleIdDeletePath = '/Consumer/DeleteRole/{roleId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerDeleteRoleRoleIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerDeleteRoleRoleIdDelete$Response(params: ConsumerDeleteRoleRoleIdDelete$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<void>> {
    return consumerDeleteRoleRoleIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerDeleteRoleRoleIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerDeleteRoleRoleIdDelete(params: ConsumerDeleteRoleRoleIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.consumerDeleteRoleRoleIdDelete$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `consumerPhotoPost()` */
  static readonly ConsumerPhotoPostPath = '/Consumer/Photo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerPhotoPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerPhotoPost$Response(params?: ConsumerPhotoPost$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<string>> {
    return consumerPhotoPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerPhotoPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  consumerPhotoPost(params?: ConsumerPhotoPost$Params, context?: HttpContext): Observable<string> {
    return this.consumerPhotoPost$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `consumerLobbiesGet()` */
  static readonly ConsumerLobbiesGetPath = '/Consumer/Lobbies';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `consumerLobbiesGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerLobbiesGet$Response(params?: ConsumerLobbiesGet$Params, context?: HttpContext): Observable<PractitionerStrictHttpResponse<Array<PractitionerLobbyModel>>> {
    return consumerLobbiesGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `consumerLobbiesGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  consumerLobbiesGet(params?: ConsumerLobbiesGet$Params, context?: HttpContext): Observable<Array<PractitionerLobbyModel>> {
    return this.consumerLobbiesGet$Response(params, context).pipe(
      map((r: PractitionerStrictHttpResponse<Array<PractitionerLobbyModel>>): Array<PractitionerLobbyModel> => r.body)
    );
  }

}
